import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { setSeo } from "@/lib/seo";

const LINKS = [
  ["nav.companyFormation", "/company-formation"],
  ["nav.bankAccount", "/banks"],
  ["nav.moreServices", "/more-services"],
  ["common.contact", "/contact"],
];

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    setSeo({ title: "Page not found (404) | UNICORP", description: "", url: window.location.href, noindex: true });
  }, []);
  return (
    <div className="min-h-screen" data-testid="not-found-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-40 pb-28 text-center">
        <span className="grid place-items-center h-14 w-14 rounded-full bg-orange-50 text-orange-600 mx-auto"><Compass className="h-7 w-7" /></span>
        <p className="mt-6 font-mono text-sm uppercase tracking-[0.2em] text-orange-700">Error 404</p>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl tracking-tight text-primary">{t("notFound.title")}</h1>
        <p className="mt-4 text-muted-foreground">{t("notFound.body")}</p>
        <div className="mt-8 grid sm:grid-cols-2 gap-3 max-w-md mx-auto">
          {LINKS.map(([l, to]) => (
            <Button key={to} variant="outline" className="rounded-sm border-slate-300 bg-card hover:bg-secondary h-11 justify-between" onClick={() => navigate(to)} data-testid={`nf-link-${to.replace(/\W+/g, "")}`}>
              {t(l)} <ArrowRight className="h-4 w-4" />
            </Button>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
